"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/close/32.js"));
var _reactPlayer = _interopRequireDefault(require("react-player"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ExternalVideo = _ref => {
  let {
    itemSrc,
    start_second,
    stop_second,
    children
  } = _ref;
  const [playClicked, setPlayClicked] = (0, _react.useState)(false);
  const [playedChanged, setPlayedChanged] = (0, _react.useState)(false);
  const src = itemSrc.includes('watch?v=') ? itemSrc.replace('watch?v=', 'embed/') : itemSrc.includes('vimeo.com') ? itemSrc.replace('vimeo.com/', 'player.vimeo.com/video/') : itemSrc;
  (0, _react.useEffect)(() => {
    window.addEventListener('keydown', function (event) {
      event.key === 'Escape' && setPlayClicked(false);
    });
  }, []);
  const isYT = itemSrc.includes('youtube');
  const origin = '&origin=https%3A%2F%2Fsia2022.sia.ch';
  const params = `?autoplay=1&controls=1&showinfo=0&modestbranding=1&rel=0&enablejsapi=1${origin}&widgetid=1`;
  const playerRef = _react.default.useRef();
  const onReady = _react.default.useCallback(() => {
    setPlayedChanged(false);
    const timeToStart = start_second;
    playerRef.current.seekTo(timeToStart, 'seconds');
  }, [playerRef.current, playedChanged]);
  const onProgress = _react.default.useCallback(_ref2 => {
    let {
      playedSeconds
    } = _ref2;
    if (!stop_second) return;
    if (stop_second - playedSeconds < -2) {
      setPlayedChanged(true);
    } else if (stop_second - playedSeconds < 0 && !playedChanged) {
      setPlayClicked(false);
    }
  }, [playerRef.current, playedChanged]);
  return /*#__PURE__*/_react.default.createElement("div", null, playClicked ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement("div", {
    className: `iframe-wrapper ${isYT ? 'youtube' : ''}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "close",
    onClick: () => setPlayClicked(false)
  }, /*#__PURE__*/_react.default.createElement(_.default, null)), isYT ? /*#__PURE__*/_react.default.createElement(_reactPlayer.default, {
    ref: playerRef,
    url: src,
    width: "100",
    height: "100%",
    controls: true,
    playing: true,
    onReady: onReady,
    onProgress: onProgress
  }) : /*#__PURE__*/_react.default.createElement("iframe", {
    width: "500",
    height: "full",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    src: `${src}${params}`,
    allowFullScreen: "1"
  })), document.body)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement("div", {
    onClick: () => setPlayClicked(true)
  }, children));
};
var _default = exports.default = ExternalVideo;